import { cva } from 'class-variance-authority';

export type VideoCardHeaderPaddingPreset = 'default' | 'home-feed';

export const videoCardHeaderPaddingVariants = cva('', {
	variants: {
		paddingPreset: {
			default: 'p-4',
			'home-feed': 'px-3 pt-3 lg:px-4 lg:pt-4'
		}
	},
	defaultVariants: {
		paddingPreset: 'default'
	}
});
